
import { Options, Vue } from "vue-class-component";
import NavHeader from "@/components/NavHeader.vue"; // @ is an alias to /src
import NavHead from "@/components/NavHead.vue"; // @ is an alias to /src

// import { ElConfigProvider } from 'element-plus'
import zhCn from "element-plus/lib/locale/lang/zh-cn";

@Options({
  components: {
    NavHeader,
    // [ElConfigProvider.name]: ElConfigProvider
    // NavHead,
  },
  watch: {
    $route: {
      handler: "onRouteChange",
      immediate: true, // 添加此选项以在组件加载时立即调用处理函数
    },
  },
})
export default class App extends Vue {
  public show_nav = true;
  //  public locale = zhCn
  public onRouteChange(newRoute: any, oldRoute: any) {
    const location = window.location.href;
    if (location.indexOf("object_memory") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("hok_domestic") != -1) {
      this.show_nav = false;
    }

    // 在这里根据 location 更新 this.show_nav 的值
    // ...
  }
  public async mounted() {
    let parentUrl = this.getParentUrl();

    if (parentUrl.indexOf("dworld.woa.com") != -1) {
      this.show_nav = false;
    }

    let location = window.location.href;
    if (location.indexOf("login_new") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("dmo_perfetto") != -1) {
      this.show_nav = false;
    }

    if (location.indexOf("custom01") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("hok") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("hok_domestic") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("awakening-skin") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("sgame") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("equipment_management") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("full") != -1) {
      this.show_nav = false;
    }
    if (location.indexOf("object_memory") != -1) {
      this.show_nav = false;
    }

    if (window.frames.length != parent.frames.length) {
      this.show_nav = false;
    }

    if (self != top) {
      this.show_nav = false;
    }
    // this.$router.push('/403');
  }

  public getParentUrl() {
    // let url = null;
    let url = "";
    if (parent !== window) {
      try {
        url = parent.location.href;
      } catch (e) {
        url = document.referrer;
      }
    }
    return url;
  }
}
